"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidUrl = isValidUrl;
exports.validateAudienceTargeting = validateAudienceTargeting;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _immutable = require("immutable");

var _filterUtils = require("AudienceTargetingUIComponents/utils/filterUtils");

var _serializer = require("AudienceTargetingUIComponents/utils/serializer");

// eslint-disable-next-line no-useless-escape
var URL_REGEX = /^((https?:)?\/\/)?[^\s\.]+\.[^\s]{2,}$/;

function isValidUrl(url) {
  var allowEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (allowEmpty && url === '') {
    return true;
  }

  return URL_REGEX.test(url);
}

function validateAudienceTargeting(audience) {
  var normalizedAudience = (0, _serializer.normalizeAudience)(audience);
  if (normalizedAudience === null) return [];
  var filter = normalizedAudience.filter;
  var values = filter.values;
  var result = values.reduce(function (errors, value) {
    var vals = (0, _filterUtils.getOrValues)(value);
    var errs = vals.map(function (val) {
      if (!val.get('values') && typeof val.get('values') !== 'boolean') {
        return [val.get('type'), 'values'];
      } else if (val.get('type') === 'URL' && val.get('operator') !== 'CONTAINS' && !isValidUrl(val.get('values'))) {
        return ['URL', 'invalidUrl'];
      } else if (_immutable.List.isList(val.get('values')) && val.get('values').size === 0) {
        return [val.get('type'), 'values'];
      } else if (val.get('type') === 'QUERY_PARAM' && (!val.getIn(['values', 'value']) || !val.getIn(['values', 'name']))) {
        return ['QUERY_PARAM', 'missingValues'];
      } else {
        return [];
      }
    });
    var filteredErrs = errs.filter(function (err) {
      return err.length && err.length === 2;
    });
    return [].concat((0, _toConsumableArray2.default)(errors), (0, _toConsumableArray2.default)(filteredErrs));
  }, []);
  return result;
}